module.exports = angular.module('eatself').component('actionButton',{
	bindings: {
		type: '@', // edit(warning),delete(danger),success,save(primary),cancel(default)
		text: '@',
	},
	transclude: true,
	controllerAs: 'vm',
	template: function($element, $attrs) {
		if ($attrs.type=='edit') {
			return `
				<button class="btn btn-warning button-height">
					<ng-transclude><i class="icone icone-editer"></i> {{::vm.text}}</ng-transclude>
				</button>`;
		} else if ($attrs.type == 'delete') {
			return `
				<button class="btn btn-danger button-height">
					<ng-transclude><i class="icone icone-supprimer"></i> {{::vm.text}}</ng-transclude>
				</button>`;
		} else if ($attrs.type == 'success') {
			return `
				<button class="btn btn-success button-height">
					<ng-transclude><i class="icone icone-supprimer"></i> {{::vm.text}}</ng-transclude>
				</button>`;
		} else if ($attrs.type == 'save') {
			return `
				<button class="btn btn-primary button-height" type="submit">
					<ng-transclude>{{::vm.text}}</ng-transclude>
				</button>`;
		} else if ($attrs.type == 'cancel') {
			return `
				<button class="btn btn-default button-height">
					<ng-transclude>{{::vm.text}}</ng-transclude>
				</button>`;
		}
	},
})
